import { createMergeReducer } from '../utils/reducer'

export type TitleIdToOffer = {
  [titleId: string]: string | undefined
}

export const reducer = createMergeReducer(
  t => t.offerAvailableOn,
  {} as TitleIdToOffer
)
